import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import ListaArquivos from '../Components/ListaArquivos'; // ajuste caminho conforme seu projeto

const EditarConteudo = () => {
    const navigate = useNavigate();

    const { conteudoID } = useParams();

    const [conteudo, setConteudo] = useState({
        tipoConteudo: '',
        titulo: '',
        observacao: '',
    });
    const [arquivos, setArquivos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchConteudo = async () => {
            try {
                const resConteudo = await api.get(`/conteudos/${conteudoID}`);
                setConteudo({
                    tipoConteudo: resConteudo.data.tipoConteudo,
                    titulo: resConteudo.data.titulo,
                    observacao: resConteudo.data.observacao || '',
                });

                const resArquivos = await api.get(`/arquivos/conteudo/${conteudoID}`);
                setArquivos(resArquivos.data);
                setLoading(false);
            } catch (err) {
                console.error(err);
                setError('Erro ao carregar dados.');
                setLoading(false);
            }
        };

        fetchConteudo();
    }, [conteudoID]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setConteudo((prev) => ({ ...prev, [name]: value }));
    };

    const handleSaveConteudo = async () => {
        setSaving(true);
        setError(null);
        try {
            await api.put(`/conteudos/${conteudoID}`, {
                tipoConteudo: parseInt(conteudo.tipoConteudo, 10),
                titulo: conteudo.titulo,
                observacao: conteudo.observacao,
            });
            alert('Conteúdo salvo com sucesso!');
        } catch (err) {
            console.error(err);
            setError('Erro ao salvar conteúdo.');
        } finally {
            setSaving(false);
        }
    };

    const renomearArquivo = async (arquivoID, novoNome) => {
        try {
            await api.put(`/arquivos/${arquivoID}`, { nomeArquivo: novoNome });
            setArquivos((prev) =>
                prev.map((arq) => (arq.arquivoID === arquivoID ? { ...arq, nomeArquivo: novoNome } : arq))
            );
            alert('Arquivo renomeado com sucesso');
        } catch (err) {
            console.error(err);
            alert('Erro ao renomear arquivo');
        }
    };

    const deletarArquivo = async (arquivoID) => {
        if (!window.confirm('Deseja realmente deletar este arquivo?')) return;
        try {
            await api.delete(`/arquivos/${arquivoID}`);
            setArquivos((prev) => prev.filter((arq) => arq.arquivoID !== arquivoID));
            alert('Arquivo deletado com sucesso');
        } catch (err) {
            console.error(err);
            alert('Erro ao deletar arquivo');
        }
    };

    if (loading) return <p>Carregando...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    return (
        <div className="container mt-4">
            <h2>Editar Conteúdo</h2>

            <div className="mb-3">
                <label htmlFor="tipoConteudo" className="form-label">Tipo do Conteúdo</label>
                <select
                    id="tipoConteudo"
                    name="tipoConteudo"
                    className="form-select"
                    value={conteudo.tipoConteudo}
                    onChange={handleChange}
                >
                    <option value="">Selecione</option>
                    <option value="1">Protocolo</option>
                    <option value="2">Fluxograma</option>
                    <option value="3">Diretriz</option>
                    <option value="4">Documentos</option>
                    <option value="5">Outros</option>
                </select>
            </div>

            <div className="mb-3">
                <label htmlFor="titulo" className="form-label">Título</label>
                <input
                    type="text"
                    id="titulo"
                    name="titulo"
                    className="form-control"
                    value={conteudo.titulo}
                    maxLength={255}
                    onChange={handleChange}
                    style={{ paddingTop: 10, paddingBottom: 10, fontSize: 14 }}
                />
            </div>

            <div className="mb-3">
                <label htmlFor="observacao" className="form-label">Observação</label>
                <textarea
                    id="observacao"
                    name="observacao"
                    className="form-control"
                    rows="1"
                    value={conteudo.observacao}
                    maxLength={500}
                    onChange={handleChange}
                    style={{ paddingTop: 10, paddingBottom: 10, fontSize: 14 }}
                />
            </div>

            <button
                className="btn btn-primary"
                onClick={handleSaveConteudo}
                disabled={saving}
            >
                {saving ? 'Salvando...' : 'Salvar Conteúdo'}
            </button>

            <hr />

            <h3>Arquivos vinculados</h3>
            <button
                className="btn btn-outline-success mt-3"
                onClick={() => navigate(`/admin/cadastrar-conteudo/${conteudoID}`)}
            >
                <i className="fas fa-upload me-1"></i> Adicionar Arquivos
            </button>
            <ListaArquivos
                arquivos={arquivos}
                onRenomear={renomearArquivo}
                onDeletar={deletarArquivo}
            />
        </div>
    );
};

export default EditarConteudo;
